import { render, staticRenderFns } from "./ShEmpty.md?vue&type=template&id=31ec3a79"
import script from "./ShEmpty.md?vue&type=script&lang=js"
export * from "./ShEmpty.md?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports